<template>
    <!-- cancel refund -->
    <el-dialog title="Cancel Order" :visible.sync="dialogCancelRefundVisible" width="600px" :before-close="handleClose">
      <div>
        <template>
          <div class="f" style="margin-bottom: 16px">
            <div class="requiredLabel requireText">{{ $t('orderList.CancelReason') }}：</div>
            <div>
              <el-select style="width: 350px" v-model="dialogParams.operationType">
                <el-option v-for="item in cancelReasonSelectList" :value="item.code" :label="item.name" :key="item.code"></el-option>
              </el-select>
            </div>
          </div>
          <div class="f">
            <div style="width: 160px; text-align: right" class="requireText">{{ $t('orderList.Verification') }}：</div>
            <div>
              <el-input type="textarea" style="width: 350px; min-height: 90px" v-model="dialogParams.remark" resize="none" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit></el-input>
            </div>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('orderList.cancel') }}</el-button>
        <el-button type="primary" @click="dialogConfirmCancelRefund">{{ $t('orderList.submit') }}</el-button>
      </span>
    </el-dialog>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogCancelRefundVisible: false,
      dialogParams: {
        refundReason: undefined,
        remark: undefined,
        kkOrderId: undefined,
        operationType: undefined
      }
    }
  },
  computed: {
    cancelReasonSelectList() {
      let arr = this.$store.state.common.cancelReasonSelectList
      if (!arr.length) {
        this.$store.dispatch('common/getCancelReasonSelectList')
      }
      return arr
    }
  },
  methods: {
    // 取消订单  拒绝收货弹窗关闭
    handleClose() {
      Object.keys(this.dialogParams).forEach((key) => {
        this.dialogParams[key] = undefined
      })
      this.dialogCancelRefundVisible = false
    },
    dialogConfirmCancelRefund() {
      const params = new FormData()
      if (this.dialogParams.operationType === undefined || this.dialogParams.operationType === null) {
        this.$message.error(this.CancellationReasonIsRequiredText)
        return
      }
      Object.keys(this.dialogParams).forEach((key) => {
        if (this.dialogParams[key] !== undefined) params.append(key, this.dialogParams[key])
      })
      API.orderCancel(params)
        .then((res) => {
          this.$message.success(res.message)
          this.handleClose()
          this.dialogCancelRefundVisible = false
          this.$emit('reFresh')
        })
        .catch((err) => {
          let message = err.message || err.data.message
          this.$message.error(message)
        })
    },
    show(kkOrderId) {
      this.dialogParams.kkOrderId = kkOrderId
      this.dialogCancelRefundVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.requiredLabel::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.requireText {
  width: 160px;
  text-align: right;
  height: 40px;
  line-height: 40px;
}
</style>
